





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Checkbox } from '@/components/atoms';
import { EDayOfTheWeek } from '@/api/OpeningHoursService';
import { upperCaseFirstLetter } from '@/utils/string';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: { Checkbox, Typography }
})
export default class SelectDayOfWeek extends Vue {
  @Prop() error?: boolean;
  @Prop() value?: string;

  get daysOfWeek() {
    return Object.values(EDayOfTheWeek);
  }

  data: Record<string, boolean> = {};

  created() {
    if (this.value) {
      this.value.split(',').forEach(day => {
        this.data[day] = true;
      });
    }
  }

  changedDay(index: number) {
    if (this.data[String(index)]) {
      delete this.data[String(index)];
    } else {
      this.data[String(index)] = true;
    }

    this.$emit('input', Object.keys(this.data));
  }

  upperDayOfWeek(day: string) {
    return upperCaseFirstLetter(day);
  }
}
